import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const TablePageContainer = /*#__PURE__*/ memo((param)=>{
    let { className, ...restProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("table-page-container relative w-full", className),
        ...restProps
    });
});
TablePageContainer.displayName = "TablePageContainer";
